import { useNavigate } from "react-router";

import { useTranslation } from "@refinedev/core";

import { Box, Link } from "@mui/material";

interface BackToLoginLinkProps {
  mt?: number;
  pb?: number;
}

export const BackToLoginLink = ({ mt, pb }: BackToLoginLinkProps) => {
  const navigate = useNavigate();
  const { translate } = useTranslation();

  return (
    <Box display="flex" justifyContent="center" mt={mt} pb={pb}>
      <Link
        component="button"
        variant="body2"
        color="text.disabled"
        underline="hover"
        onClick={() => navigate("/login")}
      >
        {translate("pages.common.backToLogin", "Back to login")}
      </Link>
    </Box>
  );
};
